import { useState } from 'react';
import { readStoredDraft, storeDraft } from '../utils/OscarConversationStorage';

/**
 * The composer's draft, kept in `sessionStorage` so it outlives a remount —
 * Expand, Shrink and Close all unmount one surface and mount the other. See
 * `readStoredDraft` for how it is scoped.
 */
export const useOscarDraft = (email: string): [string, (text: string) => void] => {
	const [draft, setDraftState] = useState(() => readStoredDraft(email));
	const setDraft = (text: string) => {
		setDraftState(text);
		storeDraft(email, text);
	};
	return [draft, setDraft];
};

export default useOscarDraft;
